import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../services/api.service';
import { _routerOptions } from '@app/app.config';

@Injectable()
export class MiscContextGuard implements Resolve<any> {
	constructor(private apiService: ApiService) {}
	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		try {
			return this.apiService.getFullCollection(_routerOptions.find((el) => el.route == route.routeConfig.path || el.routeUrl == state.url).dbColl);
		} catch (e) {
			console.error(e);
			return null;
		}
	}
}
